import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuth } from '../lib/firebase';
import { signOut } from "firebase/auth";
import { auth } from "../lib/firebase";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // loading

  const logout = async () => {
    try {
      await signOut(auth);
      setUser(null);
    } catch (e) {
      console.error("Logout error:", e);
    }
  };

  useEffect(() => {
  const unsub = onAuth((u) => {
    console.log("AUTH USER =", u);
    setUser(u ?? null);
  });

  return unsub;
}, []);

  return (
    <Ctx.Provider value={{ user, logout }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);